import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const OrganizationsComponent = lazy(async () => await import("@/pages/dashboard/control/organizations"))
// const OrganizationsFormComponent = lazy(async () => await import("@/pages/dashboard/control/organizations/Form"))
const OrganizationsViewComponent = lazy(async () => await import("@/pages/dashboard/control/organizations/View"))

export const controlOrganizationsRoutes: CustomRoute = {
  path: "organizations",
  handle: { i18Key: "organizations" },
  children: [
    {
      index: true,
      Component: OrganizationsComponent
    },
    {
      path: "view/:organizationId",
      handle: { i18Key: "view" },
      Component: OrganizationsViewComponent
    }
    // {
    //   path: "create",
    //   handle: { label: "Добавить новый", i18Key: "create" },
    //   Component: OrganizationsFormComponent
    // },
    // {
    //   path: "edit/:organizationId",
    //   handle: { label: "Редактировать", i18Key: "edit" },
    //   Component: OrganizationsFormComponent
    // },
  ]
}
